import { z } from 'zod';

/** Every domain module of the platform. Modules outside milestone 1 are registered
 *  and disabled: enabling them is configuration, not a refactor. */
export const MODULE_KEYS = [
  'identity',
  'privacy',
  'operations',
  'mapping',
  'teams',
  'personnel',
  'resources',
  'devices',
  'drones',
  'communications',
  'tracking',
  'reports',
  'integrations',
  'connectivity',
  // Sentinel Field, the operators' app (ADR 0028, ADR 0029).
  'field',
] as const;

export const moduleKeySchema = z.enum(MODULE_KEYS);
export type ModuleKey = z.infer<typeof moduleKeySchema>;
